/* istanbul ignore file */
import { hot } from 'react-hot-loader/root'
import React from 'react'

import Analytics from './components/Analytics'

import { AnalyticsProvider } from '@elparking/analytics'

const App = (props) => {
    return (

        <AnalyticsProvider analyticService={window.utag}>
            <Analytics {...props} />
        </AnalyticsProvider>

    )
}

export default hot(App)
